import React from "react";
import FAQ from "@/components/Common/FAQ";
import { createClient } from "../../../../../prismicio";
import Metadata from "@/components/Metadata";
import LayoutVariant from "@/components/LayoutVariant";
import SchemaScript from "@/components/SchemaScript";
import SingleWatchPage from "@/components/watch-buyers-nyc/single-watch";
import SingleSubPage from "@/components/watch-buyers-nyc/single-sub-page";

const WatchIndividual = ({
  uid,
  globals,
  pageWatches,
  pageData,
  watches,
  type,
  common,
}) => {
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  return (
    <LayoutVariant data={commonComponents}>
      <SchemaScript data={pageData?.schema_json} />
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path={`/what-we-buy/watch-buyers-nyc/${uid}`}
      />
      {type === "watches_individual_page" && (
        <SingleWatchPage
          pageData={pageData}
          components={components}
          commonComponents={commonComponents}
          watches={watches}
        />
      )}
      {type === "watch_buyers_sub" && (
        <SingleSubPage
          pageData={pageData}
          components={components}
          common={common}
        />
      )}
    </LayoutVariant>
  );
};

export default WatchIndividual;

export async function getStaticProps({ params, previewData }) {
  const client = createClient({ previewData });

  const { watch } = params;

  let page = null;
  let subPage = null;

  try {
    page = await client.getByUID("watches_individual_page", params.watch);
  } catch (e) {
    page = null;
  }

  try {
    subPage = await client.getByUID("watch_buyers_sub", params.watch);
  } catch (e) {
    subPage = null;
  }

  const globals = await client.getSingle("globals");
  const common = await client.getSingle("common");
  const pageWatches = await client.getAllByType("rolex_watch");

  const watches = filterWatches(pageWatches, params.uid);

  if (!page && subPage) {
    return {
      props: {
        uid: params.watch,
        pageData: subPage?.data,
        type: subPage?.type || subPage?.type,
        globals,
        watches,
        common,
      },
    };
  }

  if (!subPage && page) {
    return {
      props: {
        uid: params.watch,
        pageData: page?.data,
        type: page?.type,
        globals,
        watches,
        common,
      },
    };
  }
  return {
    props: {},
  };
}

export async function getStaticPaths() {
  const client = createClient();
  const pages = await client.getAllByType("watches_individual_page");
  const subPages = await client.getAllByType("watch_buyers_sub");
  const watchPaths = pages.map((page) => {
    return { params: { watch: page?.uid } };
  });
  const subPagePaths = subPages.map((page) => {
    return { params: { watch: page?.uid } };
  });
  const paths = [...watchPaths, ...subPagePaths];
  return {
    paths,
    fallback: false,
  };
}

const filterWatches = (pageWatches, uid) => {
  let watches = [];
  if (uid === "rolex-watch-buyers") {
    const filteredWatches = pageWatches.filter(
      (watch) => watch.data.watch_brand_category === "Rolex",
    );
    watches = filteredWatches.sort((a, b) => {
      return a.uid.localeCompare(b.uid);
    });
  } else if (uid === "patek-phillipe-watch-buyers") {
    const filteredWatches = pageWatches.filter(
      (watch) => watch.data.watch_brand_category === "Patek Phillipe",
    );
    watches = filteredWatches.sort((a, b) => {
      return a.uid.localeCompare(b.uid);
    });
  } else if (uid === "audemars-piguet-watch-buyers") {
    const filteredWatches = pageWatches.filter(
      (watch) => watch.data.watch_brand_category === "Audemars Piguet",
    );
    watches = filteredWatches.sort((a, b) => {
      return a.uid.localeCompare(b.uid);
    });
  } else if (uid === "richard-mille-watch-buyers") {
    const filteredWatches = pageWatches.filter(
      (watch) => watch.data.watch_brand_category === "Richard Mille",
    );
    watches = filteredWatches.sort((a, b) => {
      return a.uid.localeCompare(b.uid);
    });
  } else {
    watches = [];
  }

  return watches;
};
